import React, { useState, useRef, useEffect } from 'react'
import Calendar from 'react-calendar'
import { useDispatch, useSelector } from 'react-redux'
import { SlCalender } from "react-icons/sl";
import { IoTimeOutline } from "react-icons/io5";
// import { Elements, useStripe, useElements, CardElement } from '@stripe/react-stripe-js'
import defaultCoach from '../../../assets/images/default-coach.png'
import { BASE_URL } from '../../../keys'
import {
    useBookSlotMutation,
    useCancelBookedSlotMutation,
    useCancelRelationMutation,
    useGetTimeSlotsMutation,
} from '../../../services/coachApi'
import { useGetCurrentUserQuery } from '../../../services/authApi'
import { useGetPriceQuery } from '../../../services/currencyApi';
import { slotActions } from '../../../services/slotSlice'
import CloseButton from '../../../UI/CloseButton'
import { ToastContainer, toast } from 'react-toastify'
import BookingError from './Popups/BookingError'
import { bookingActions } from '../../../services/bookingSlice'
import Feedback from './Popups/Feedback'
import { useNavigate ,useLocation} from 'react-router-dom'
import loader from '../../../assets/images/loader.gif'
import { useGetCategoriesQuery } from '../../../services/categoryApi';
// import moment from 'moment'
import moment from 'moment-timezone';
import Backdrop from '../../../UI/Backdrop'
import { Button } from 'antd';
import emptyavatar from '../../../assets/images/emptyavatar.webp'
const currentTime = moment(new Date(), 'h:mm:ss A').format('HH:mm')
const currentDate = moment(new Date()).format('YYYY-MM-DD')

const Modal = (props) => {
    // console.log(props);
   const [timeSlot, setTimeSlot] = useState('')
   const [showModal, setShowModal] = useState(true); // Controls overall 
    const [amount, setAmount] = useState('')
    const [currency, setCurrency] = useState('')
  
  const location = useLocation();
const [payNow,setPayNow]=useState(false)
const [bookNow,setBookNow]=useState(true)
    const [message, setMessage] = useState('')
    const [errorBooking, setErrorBooking] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [feedback, setFeedback] = useState(false)
     const [loadingToCancel, setLoadingToCancel] = useState(false);
     const dispatch = useDispatch()
     const bookedSlots = useSelector((state) => state.slotReducers.booking)
    const leaveSlots = useSelector((state) => state.slotReducers.leaves)
const bookingId = useSelector((state) => state.bookingReducer.bookingId)
    const coachId = useSelector((state) => state.bookingReducer.coachId)
// const elements = useElements();
    const [value, setValue] = useState(new Date())
  //  console.log(coachId);
   
    const { data, isSuccess, isLoading, isError } = useGetCategoriesQuery()
      //  console.log('Categories', data?.data)
    const [bookSlot, { isLoading: slotBookingLoading }] = useBookSlotMutation()
     const [cancelBookedSlot] =
        useCancelBookedSlotMutation()
    const [
        getTimeSlots,
        { isLoading: slotsLoading, isError: getSlotsError, error },
    ] = useGetTimeSlotsMutation()
    const [cancelRelation, { isLoading: cancelLoading }] =
        useCancelRelationMutation()

    const { data: userDetails } = useGetCurrentUserQuery({})
   const categoryId=localStorage.getItem("categoryid")
    const storedCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
   
    
const currencyId = storedCurrency?.id;
   const { data:getPriceData } = useGetPriceQuery({ categoryId, currencyId });
  
    const slots = useSelector((state) => state.slotReducers.slots)
  
    const navigate = useNavigate()


useEffect(() => {
  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.async = true;
  document.body.appendChild(script);
}, []);

useEffect(() => {
 
  
  if (getPriceData?.price && getPriceData.price.amount) {
    setAmount(getPriceData?.price.amount);
    setCurrency((storedCurrency.code || 'AED').toUpperCase());
  } else {
    // Fallback: find category from allCategory by categoryId
    const categories = data?.data || [];
    const category = categories.find(cat => cat.id === Number(props.categoryId));
    
    
    if (category && category.price && category.price.amount) {
       
        
      setAmount(getPriceData.price.amount);
      setCurrency((storedCurrency.code || 'AED').toUpperCase());
    } else {
      // If still not found, fallback to defaults or ''
      setAmount('');
      setCurrency('AED');
    }
  }
}, [props.price, props.categoryId, data]);
    function formatDate() {
        var d = value,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()

        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day

        return [year, month, day].join('-')
    }
    // console.log(formatDate(), 'value')

 

    useEffect(() => {
      //  console.log(props?.price?.currency_code);
       
        setAmount(getPriceData?.price?.amount);
        setCurrency((storedCurrency.code || 'AED').toUpperCase());
    }, [getPriceData?.price?.amount, props?.price?.currency_code]);
// console.log(amount);
// console.log(storedCurrency.code);

    const bookYourSlot = async () => {
        const formData = new FormData()
        formData.append('date', formatDate())
        formData.append('coach_id', props.coachId)
        formData.append('category_id', props.categoryId)
        formData.append('time_slot', timeSlot)
        formData.append('amount', amount)
        formData.append('currency', storedCurrency.code)
       
        // console.log('FormData Values:')
        // for (let pair of formData.entries()) {
        //     // console.log(`${pair[0]}: ${pair[1]}`)
        // }

        try {
            const response = await bookSlot(formData)
            

            if (response?.data?.code === 'Success') {
             
            //   razorpay
const { RZP_order_id, data: bookingId } = response.data;

      const options = {
        key:"rzp_live_RcR0Eyfy5CToJ5",
        // key: "rzp_test_nlYlH13408kYk6", // test Razorpay key
        amount: parseInt(getPriceData?.price?.amount) * 100, 
        currency: storedCurrency.code,
        name: "hapsmiths",
        description: "Slot Booking",
       
        order_id: RZP_order_id,
        handler: function (response) {
          // console.log("Payment Success:", response);

         if(response){
          toast.success('Payment Successful! Redirecting...');
          setTimeout(() => {
            navigate(`/chat/${props.coachId}`);
          }, 2000);}else{
             toast.error('Payment failed try again');
            setPayNow(true)
          }
        },
        prefill: {
          name: userDetails?.data?.name || '',
          email: userDetails?.data?.email || '',
        },
        theme: {
          color: "#F77F11",
        },
         "modal": {
        "ondismiss": function () {
            setPayNow(true)
            toast.error("Payment Failed")
           
        }
    }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
            setPayNow(false)    
            }
            

            if (response.error.originalStatus === 500) {
                setErrorBooking(true)
                setErrorMessage('Something went wrong! Please try again.')
            } else {
                setErrorBooking(true)
                 setPayNow(false)
                if (
                    response.error.data.data.error[0] ===
                    'Please give previous session a rating.'
                ) {
                    setErrorMessage(response.error.data.error_msgs[0]) 
                } else {
                    setErrorMessage(response.error.data.data.error[0])
                }
            }
if(response?.data?.constant_key==="booking_already_done"){
    
    
setErrorBooking(true)

}
           
            if (response.error.data.data.error[0]) {
                
                setPayNow(false)
                setErrorBooking(true)
                dispatch(
                    bookingActions.bookingError({
                        bookingId: response.error.data.data_key[0][0],
                        coachId: response.error.data.data_key[0][1],
                    })
                )
            }
          
           
        } catch (error) {
            

           
            
        }
    }



    
const cancelBookedSlotHandler = async () => {
   
  const formData = new FormData();
  formData.append('booking_id', parseInt(bookingId));
  formData.append('coach_id', parseInt(coachId));
  formData.append('category_id', props.categoryId);

  try {
    const response = await cancelBookedSlot(formData);
   
    
    if (response?.data?.code === 'Success') {
      toast.success('Booking Cancelled Successfully!Now Try new Booking');

     
      setErrorBooking(false); 
           
setPayNow(true)
      return response; // return to let pauseRelationHandler re-book
    } else {
      toast.error('Cancel failed');
      return response;
    }

  } catch (err) {
    
    toast.error('Cancel booking failed');
    return { error: err };
  }
};
   
    const pauseRelationHandler = async () => {
       
        const formData = new FormData()

        formData.append('date', formatDate())
        formData.append('coach_id', props.coachId)
        formData.append('category_id', props.categoryId)
        formData.append('time_slot', timeSlot)
        formData.append('pause_relation', 'yes')
        formData.append('amount', amount)
        formData.append('currency', currency)
        try {
            const response = await cancelRelation(formData)
            //eslint-disable-next-line
            
           
             if (response?.data?.code === 'Success') {
            //   razorpay
const { RZP_order_id, data: bookingId } = response.data;

      const options = {
         key:"rzp_live_RcR0Eyfy5CToJ5",
        // key: "rzp_test_nlYlH13408kYk6", // test Razorpay key
        amount: parseInt(amount) * 100, 
        currency: storedCurrency.code,
        name: "hapsmiths",
        description: "Slot Booking",
        // image: "/your-logo.png", // optional
        order_id: RZP_order_id,
        handler: function (response) {
          // console.log("Payment Success:", response);

         
          toast.success('Payment Successful! Redirecting...');
          setTimeout(() => {
            navigate(`/chat/${props.coachId}`);
          }, 2000);
        },
        prefill: {
          name: userDetails?.data?.name || '',
          email: userDetails?.data?.email || '',
        },
        theme: {
          color: "#F77F11",
        },
         "modal": {
        "ondismiss": function () {
            setPayNow(true);
           
        }
    }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
            // setPayNow(false)    
            }
if(response?.data?.constant_key==="booking_already_done"){
   const cancelresponse=await cancelBookedSlotHandler();
  //  console.log(cancelresponse);
 if(cancelresponse?.data?.code==='Success'){
   
   
    
return;
}

}
  
           
            setErrorBooking(false)
            // toast.success(
            //     'Paused previous relationship!Now try new Booking'
            // )
           
           

            if (response.error.data.data.error[0]) {
                dispatch(
                    bookingActions.bookingError({
                        bookingId: response.error.data.data_key[0][0],
                        coachId: response.error.data.data_key[0][1],
                    })
                )
            }
            // setErrorBooking(false)
        } catch (error) {
            // console.log(error)
        }
    }


    const mainRef = useRef(null)

const handleClick = async () => {
  const formData = new FormData();
  formData.append('date', formatDate());
  formData.append('coach_id', props.coachId);
  formData.append('category_id', props.categoryId);

  try {
    const response = await getTimeSlots(formData);
    // console.log('API response:', response);

    // Handle error or no slots case early
    if (
      response?.data?.code !== 'Success' ||
      response?.error?.data?.error_key === 'all_slots'
    ) {
      // Clear Redux slot states to prevent stale slots showing
      dispatch(slotActions.getSlots([]));
      dispatch(slotActions.getBookedSlots([]));
      dispatch(slotActions.getLeaveSlots([]));

      setMessage('Try changing date.');
      return; // Stop further processing
    }

    // Safely access data
    const data = response?.data?.data;

    if (!data?.slots || !Array.isArray(data.slots) || data.slots.length === 0) {
      // No slots found
      dispatch(slotActions.getSlots([]));
      dispatch(slotActions.getBookedSlots([]));
      dispatch(slotActions.getLeaveSlots([]));

      // setMessage('No slots found! Try changing date.');
      return;
    }

    // Convert slot times from UTC to user timezone or local
     const deviceTimezone = localStorage.getItem('device_timezone')
    const userTimezone = userDetails?.data?.timezone?.name || deviceTimezone;
    // console.log(userTimezone,deviceTimezone);
    
    const slotTimes = data.slots.map((s) => {
      const utcDateTime = moment.utc(`${s.session_date} ${s.slot}`, 'YYYY-MM-DD HH:mm');

      const localMoment = userTimezone
        ? utcDateTime.clone().tz(userTimezone)
        : utcDateTime.local();

      return {
        time: localMoment.format('HH:mm'),
        available: s.is_slot_available,
      };
    });


    // Update Redux state with fetched slots and related info
    dispatch(slotActions.getSlots(slotTimes));
    dispatch(slotActions.getBookedSlots(data.booking || []));
    dispatch(slotActions.getLeaveSlots(data.leaves || []));

    // Clear message since slots are available
    setMessage('');
  } catch (error) {
    // On network or unexpected error, clear slots and show message
    dispatch(slotActions.getSlots([]));
    dispatch(slotActions.getBookedSlots([]));
    dispatch(slotActions.getLeaveSlots([]));
    // setMessage('No slots found! Try changing date.');
    
  }
};


    useEffect(() => {
        handleClick()
        //eslint-disable-next-line
    }, [value])


    return (
        <>
           <Backdrop />

            <div className="fixed z-[999] w-screen h-screen top-0 left-0 flex justify-center items-center bg-[#4040407c] findTherapistCalModal">
                <ToastContainer hideProgressBar />

                {errorBooking && (
                    <BookingError
                        cancelBookedSlotHandler={cancelBookedSlotHandler}
                        loadingToCancel={loadingToCancel}
                        onClickYes={pauseRelationHandler}
                        cancelLoading={cancelLoading}
                        setFeedback={setFeedback}
                        setErrorBooking={setErrorBooking}
                        onClickNo={() => {setErrorBooking(false); 
                          navigate(0);
                          // navigate(`/chat/${props.coachId}`)
                          //  navigate(location.pathname, { replace: true });
                        }}
                        message={errorMessage}
                    />
                     
                )}

                {feedback && (
                    <Feedback
                        setFeedback={setFeedback}
                        setErrorBooking={setErrorBooking}
                    />
                )}

                {bookNow && !errorBooking && !feedback && (
                    <div className="w-5/12 md:w-9/12 xs:w-full sm:w-full bg-white rounded-2xl overflow-hidden">
                        <div
                            onClick={handleClick}
                            ref={mainRef}
                            className="h-10 w-full pt-2 mb-3 relative bg-[#FDE9D8] text-center font-bold"
                        >
                            Book Your Appointment
                            {props.btnClick === 'no' && (
                                <CloseButton
                                    onClick={props.closeModal}
                                    className="absolute top-2 right-10 cursor-pointer text-gray-500"
                                />
                            )}
                            {props.btnClick === 'yes' && (
                                <CloseButton
                                    onClick={() =>
                                        navigate(`/chat/${props.coachId}`)
                                    }
                                    className="absolute top-2 right-10 cursor-pointer text-gray-500"
                                />
                            )}
                        </div>

                        <Calendar
                            onChange={(e) => setValue(e)}
                            defaultValue={new Date()}
                            minDate={new Date()}
                            maxDate={
                                new Date(Date.now() + 6 * 24 * 60 * 60 * 1000)
                            }
                            className="mx-auto"
                            value={value}
                        />
<div className='flex items-center justify-center py-1 text-gray-400'>Hey there! You're on {localStorage.getItem('device_timezone')} timezone</div>
                      
<div
  id="slotContainer"
  className="flex flex-wrap justify-center gap-2 my-3 w-full px-10"
>
  {error?.data?.error_key === 'all_slots' && (
    <p>All slots are booked for this date.</p>
  )}

  {!error?.data?.error_key && getSlotsError && (
    <p className="text-center w-full">
      An error occurred! Please try changing date or coach.
    </p>
  )}

  {!slotsLoading ? (
    Array.isArray(slots) && slots.length > 0 ? (
      <>
        {slots.map((item, index) => {
          const slotTime = moment(item.time, 'HH:mm');
          const current = moment(currentTime, 'HH:mm');

          const isToday =
            moment(currentDate).format('YYYY-MM-DD') ===
            moment(value).format('YYYY-MM-DD');

          const isPast = isToday && current.isAfter(slotTime);
          const isBooked = (bookedSlots || []).includes(item.time);
          const isLeave = (leaveSlots || []).includes(item.time);
          const isUnavailable = item.available === 0;

          const isDisabled = isPast || isBooked || isLeave || isUnavailable;

          // 🩶 Disabled (past/booked/leave/unavailable)
          if (isDisabled) {
            return (
              <div
                key={index}
                className="p-1 flex items-center w-20 rounded-[40px] border-gray border-2 text-center text-gray-500 cursor-no-drop opacity-50"
              >
                <div className="w-2 h-2 rounded-full bg-gray-300 mr-2"></div>
                {item.time}
              </div>
            );
          }

          // 🟠 Available (clickable)
          return (
            <div
              key={index}
              onClick={() => setTimeSlot(item.time)}
              className={
                'active:bg-orange p-1 flex items-center w-20 cursor-pointer rounded-[40px] border-[#FFC289] border-2 text-center ' +
                (timeSlot === item.time
                  ? ' bg-orange text-white'
                  : ' text-gray-500')
              }
            >
              <div className="w-2 h-2 rounded-full bg-heavyBorder mr-2"></div>
              {item.time}
            </div>
          );
        })}
      </>
    ) : (
      <div>{message || 'No slots found!'}</div>
    )
  ) : (
    'Loading...'
  )}
</div>





                        <div className="flex  items-center flex-col justify-center py-3 w-full gap-4">
                           
                            <button
                            onClick={()=>{setPayNow(true); setBookNow(false)}}
                                // onClick={bookYourSlot}
                                // disabled={slotBookingLoading}
                                disabled={timeSlot ? false : true}
                                className=" w-36 bg-[#FFDBB0] text-[#F77F11] rounded-[40px] p-2 font-ubuntu font-bold disabled:opacity-15"
                            >
                                {slotBookingLoading ? (
                                    <img
                                        src={loader}
                                        className="w-8 h-8 mx-auto"
                                        alt=""
                                    />
                                ) : (
                                    'Confirm'
                                )}
                            </button>
                        </div>
                    </div>
                )}
                {payNow &&
                <div className="w-5/12 md:w-9/12 xs:w-full sm:w-full bg-white rounded-2xl overflow-hidden">
                <div className="h-10 w-full pt-2 mb-3 relative bg-[#FDE9D8] text-center font-bold"><span>Confirm Payment</span><button className='absolute right-3' onClick={()=>{setPayNow(false);setBookNow(true)}}>x</button></div>
               
                     <div className="flex items-start gap-8 pt-8 px-4">
        {/* <div className="w-16 h-16 rounded-full overflow-hidden bg-gray-300"> */}
          <img className='w-[55px] h-[55px] rounded-full object-cover' alt="image"
        src= {props?.coachImage ? `${BASE_URL}${props?.coachImage}` : emptyavatar} 
       onError={(e) => {
    e.currentTarget.src = emptyavatar;
  }} />

       
        {/* </div> */}

        <div className="flex-1">
          <div className="text-lg font-semibold ">{props?.coachName} 
            {/* <span className="text-sm font-normal text-gray-500">{props?.categoryId === '2' ? "(Mental Health)" : "(Physical)"}</span> */}
            </div>
          {/* <div className="text-sm pt-2">CoachID:{props?.coachId}</div> */}

          <div className="flex items-center text-sm  mt-3 space-x-4 gap-7">
            <div className="flex items-center gap-1">
              <span className="material-icons text-base"><SlCalender /></span>
              <span>{formatDate()}</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="material-icons text-base"><IoTimeOutline /></span>
              <span>{timeSlot}</span>
            </div>
          </div>
          
<div className='p-1 mt-2 font-semibold'>
  {props?.sessionduration.replace(/_/g, '-')} consultation with your coach
</div>
          <div className="text-xl text-lightOrange font-semibold mt-4">
             {storedCurrency?.symbol} {getPriceData?.price?.amount}
          </div>
        </div>
      </div>

      <div className="flex justify-between mt-6 gap-4 px-4 pb-10">
        <button className="w-1/2 bg-[#FFDBB0] text-[#F77F11] rounded-[40px] p-2 font-ubuntu font-bold disabled:opacity-15"onClick={()=>{setPayNow(false);setBookNow(true)}}>
          Cancel
        </button>
        <button className="w-1/2 bg-[#FFDBB0] text-[#F77F11] rounded-[40px] p-2 font-ubuntu font-bold disabled:opacity-15" onClick={bookYourSlot}>
          Pay Now
        </button>
       
      </div>
                    </div>
                    }
            </div>
        </>
    )
}

export default Modal

